module.exports = __webpack_public_path__ + "img/MTABAPPFEV6.7ada305a.svg";